// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /squares/preview-games.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeSquaresPreviewGamesBody,
  typeSquaresPreviewGamesOutput200,
} from "../../sdk/squares/postSquaresPreviewGames";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildSquaresPreviewGamesQueryKey(
  payload: typeSquaresPreviewGamesBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`leagueKey:${JSON.stringify(payload.leagueKey)}`);
  queryKeySegments.push(`gridType:${JSON.stringify(payload.gridType)}`);
  queryKeySegments.push(`gameRule:${JSON.stringify(payload.gameRule)}`);
  return [
    "post:squares:squaresPreviewGames",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeSquaresPreviewGamesOutput200,
    unknown,
    typeSquaresPreviewGamesOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useSquaresPreviewGames(
  payload: typeSquaresPreviewGamesBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildSquaresPreviewGamesQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postSquaresPreviewGames(payload),
    ...resolvedOptions,
  });
}
